import axiosInstance from '../utils/axios-instance';
import { actionCreator, createRequestTypes } from '../utils/helpers';
import { getErrorMessage } from '../utils/helpers';

export const EMPTY_GUEST_ORDER = createRequestTypes('EMPTY_GUEST_ORDER');
export const CHECK_AVAILABLE_PLANS = createRequestTypes('CHECK_AVAILABLE_PLANS');
export const CREATE_NO_SERVICE_ACCOUNT = createRequestTypes('CREATE_NO_SERVICE_ACCOUNT');
export const CREATE_ACCOUNT = createRequestTypes('CREATE_ACCOUNT');
export const PLAN_DETAILS = createRequestTypes('PLAN_DETAILS');
export const CREATE_ORDER = createRequestTypes('CREATE_ORDER');
export const CHECK_EMAIL_VERIFIED = createRequestTypes('CHECK_EMAIL_VERIFIED');
export const UPDATE_ACCOUNT_EMAIL = createRequestTypes('UPDATE_ACCOUNT_EMAIL');
export const EMPTY_ERROR_REDUCER = 'EMPTY_ERROR_REDUCER';

export const getCheckAvailability = (address, locationId) => async (dispatch, getState) => {
	dispatch(actionCreator.request(CHECK_AVAILABLE_PLANS));
	try {
		const response = await axiosInstance.post(`/public/order/plans/${locationId}`, address);
		dispatch(actionCreator.success(CHECK_AVAILABLE_PLANS, response.data));
		return response.data;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(CHECK_AVAILABLE_PLANS, mockError));
	}
};

export const emptyCheckAvailability = () => (dispatch) => {
	dispatch(actionCreator.empty(CHECK_AVAILABLE_PLANS));
};

export const createNoServiceAccount = (account) => async (dispatch, getState) => {
	dispatch(actionCreator.request(CREATE_NO_SERVICE_ACCOUNT));
	try {
		const response = await axiosInstance.post(`/public/account`, account);
		dispatch(actionCreator.success(CREATE_NO_SERVICE_ACCOUNT, response.data));
		return response.data;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(CREATE_NO_SERVICE_ACCOUNT, mockError));
	}
};

export const createAccount = (account) => async (dispatch, getState) => {
	dispatch(actionCreator.request(CREATE_ACCOUNT));
	try {
		const response = await axiosInstance.post(`/public/account`, account);
		dispatch(actionCreator.success(CREATE_ACCOUNT, response.data));
		return response.data;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(CREATE_ACCOUNT, mockError));
	}
};

export const getPlanDetails = (locationId, planId) => async (dispatch, getState) => {
	let params = {
		locationId,
		planId
	};

	dispatch(actionCreator.request(PLAN_DETAILS));
	try {
		const response = await axiosInstance.get(`/public/order/plan/`, { params: params });

		// This is hack - the response error format need to be changed
		if (response.success !== false) {
			dispatch(actionCreator.success(PLAN_DETAILS, response.data));
		}
		return response.data;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(PLAN_DETAILS, mockError));
	}
};

export const emptyPlanDetails = () => (dispatch) => {
	dispatch(actionCreator.empty(PLAN_DETAILS));
};

export const createNewOrder = (orderData, orderType) => async (dispatch, getState) => {
	dispatch(actionCreator.request(CREATE_ORDER));
	try {
		let response;
		if (orderType === 'SIGNUP') {
			let signUp = await axiosInstance.post(`public/order/newsignup`, orderData);
			response = { ...signUp.data, orderType: 'SIGNUP' };
		} else if (orderType === 'SURVEY') {
			let survey = await axiosInstance.post(`public/order/newsurvey`, orderData);
			response = { ...survey.data, orderType: 'SURVEY' };
		} else if (orderType === 'ACTIVE') {
			let survey = await axiosInstance.post(`public/order/newservice`, orderData);
			response = { ...survey.data, orderType: 'ACTIVE' };
		} else {
			let survey = await axiosInstance.post(`public/order/newservice`, orderData);
			response = { ...survey.data, orderType: 'ACTIVE' };
		}
		dispatch(actionCreator.success(CREATE_ORDER, response));
		return response;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(CREATE_ORDER, mockError));
	}
};

export const checkEmailVerified = (accountId) => async (dispatch, getState) => {
	dispatch(actionCreator.request(CHECK_EMAIL_VERIFIED));
	try {
		let response = await axiosInstance.get(`public/account/${accountId}/email/verified`);
		dispatch(actionCreator.success(CHECK_EMAIL_VERIFIED, response.data));
		return response;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(CHECK_EMAIL_VERIFIED, mockError));
	}
};

export const updateAccountEmail = (accountId, accountNumber, email) => async (dispatch, getState) => {
	dispatch(actionCreator.request(UPDATE_ACCOUNT_EMAIL));
	try {
		let params = {
			email
		};

		let response = await axiosInstance.get(`public/account/${accountId}/${accountNumber}/email/update`, { params: params });
		dispatch(actionCreator.success(UPDATE_ACCOUNT_EMAIL, response.data));
		return response;
	} catch (err) {
		let language = getState().language.language;
		let mockError = getErrorMessage(err.response, language);
		dispatch(actionCreator.failure(UPDATE_ACCOUNT_EMAIL, mockError));
	}
};

export const emptyCreateNewOrder = () => (dispatch) => {
	dispatch(actionCreator.empty(CREATE_ORDER));
};

export const emptyGuestOrder = () => (dispatch) => {
	dispatch(actionCreator.success(EMPTY_GUEST_ORDER));
	// dispatch(actionCreator.clear(CREATE_NO_SERVICE_ACCOUNT));
	dispatch({ type: EMPTY_ERROR_REDUCER });
};

export const clearNoServiceAccountError = () => (dispatch) => {
	dispatch(actionCreator.clear(CREATE_NO_SERVICE_ACCOUNT));
};
